import { User } from "@auth0/auth0-react";

export const setTokenInfo = (user?: User) => {
  user && window.sessionStorage.setItem("token_info", JSON.stringify(user));
};
